const envelopeField = value => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
};
export const parseErrorEnvelope = (envelope = {}) => ({
  message: envelopeField(envelope.error_msg),
  hint: envelopeField(envelope.error_hint),
  technicalDetail: envelopeField(envelope.error_detail),
  reference: envelopeField(envelope.trace_id),
  errorCode: envelopeField(envelope.error_code)
});
export const getErrorMessage = (envelope = {}) => parseErrorEnvelope(envelope).message;